import { render, staticRenderFns } from "./RF01.vue?vue&type=template&id=397d0dd4&lang=true"
import script from "./RF01.js?vue&type=script&lang=js&external"
export * from "./RF01.js?vue&type=script&lang=js&external"
import style0 from "./RF01.vue?vue&type=style&index=0&id=397d0dd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports